import React from "react"

const Header = ({ children }) => (
  <header className="header-container">
    <div className="site-header">{children}</div>
  </header>
)

export default Header
